/**
 * @typedef {Object} SegmentChangesItem данные изменения в сегменте при добавлении, удалении, изменении количества услуг
 * @property {String} currency ISO3 код валюты
 * @property {String} item_id
 * @property {Number} item_price
 * @property {Number} item_quantity новое количество
 * @property {Number} item_quantity_diff изменение количества, может быть отрицательном при уменьшении
 * @property {Number} passenger_id
 * @property {Number} segment_id
 */
var SvcsScreenLuggage = (function ($) {

    SvcsScreenLuggage = function (options) {
        var that = this;

        that.class = {
            pills_wrapper: 'js-pills-wrapper',
            svc_luggage_wrapper: 'js-svc-luggage-wrapper',
            svc_border: 'js-svc-border',
            svc_title: 'js-svc-title',
            svc_sub_title: 'js-svc-sub-title',
            svc_content: 'js-svc-content',
            svc_action: 'js-svc-action',
            svc_action_add: 'js-svc-action-add',
            svc_action_edit: 'js-svc-action-edit',
            svc_airline_categories: 'js-svc-airline-categories',
            svc_airline_category: 'js-svc-airline-category',
            is_active: 'is-active',
            svc_hint: 'js-svc-hint',
            svc_hint_top: 'top-left',
            svc_badge_added: 'js-svc-badge-added',
            svc_badge_added_quantity: 'js-svc-badge-added-quantity',
            svc_badge_paid: 'js-svc-badge-paid',
            svc_badge_paid_quantity: 'js-svc-badge-paid-quantity',
            svcs_luggage_total_drawer_call: 'js-luggage-total-call',
            svcs_luggage_total_segment: 'js-side-total-segment',
            svcs_luggage_total_content: 'js-svcs-luggage-total-content',
            svcs_luggage_total_item: 'js-side-total-item',
            svcs_luggage_total_item_count: 'js-side-total-item-count',
            svcs_luggage_total_item_amount: 'js-side-total-item-amount',
            svcs_luggage_total_amount: 'js-side-total-amount',
            svcs_luggage_total_drawer: 'js-svcs-luggage-total-value',

            svc_action_submit: 'js-svc-action-submit',
            svc_action_submit_text_desktop: 'js-svc-action-submit-text-desktop',
            svc_action_submit_text_mobile: 'js-svc-action-submit-text-mobile',
            svc_action_confirm: 'js-svc-action-confirm',
            svc_action_cancel: 'js-svc-action-cancel',
            svc_card_wrapper: 'js-svc-card-wrapper',
            svc_card_min_price: 'js-min-price'
        };

        that.selectors = {
            select_segment_passengers: UISelectSegmentPassengers.prototype.selectors.select_segment_passengers,
            luggage_rules_link: '.js-luggage-rules-link'
        };

        //
        that.options = options;

        // DOM
        that.$wrapper = that.options['$wrapper'];

        if (that.$wrapper && that.$wrapper.length) {
            // CONST
            that.order_currency = that.options['order_currency'] || '';
            that.order_segments_ids = that.options.order_segments_ids;
            that.order_passengers_ids = that.options.order_passengers_ids;
            
            that.screen_mode = that.options['screen_mode'] || 'screen';
            that.items_unpaid_initial_count = that.__countItemsQuantity(
                [].concat(
                    options['items_unpaid'] || [],
                    options['items_default'] || []
                )
            );

            that.luggage_incomplete_warning_enable = that.options['luggage_incomplete_warning_enable'];
            that.luggage_incomplete_warning_html = that.options.modals['luggage_incomplete_warning_html'];
            
            that.luggage_additional_empty_warning_enable = that.options['luggage_additional_empty_warning_enable'];
            that.luggage_additional_empty_warning_html = that.options.modals['luggage_additional_empty_warning_html'];

            // ограничение на общее количество питомцев в салоне для конкретного пассажиро-сегмента
            // фильтрация происходит по маске `PET_CABIN` для поля `airline_svc.code`
            // и type=`airline_svc.type=`HAND_LUGGAGE`
            that.pet_cabin_max_quantity = {
                code_mask: 'PET_CABIN',
                type: 'HAND_LUGGAGE',
                max_quantity: 1
            };

            // ограничение количества в пассажиро-сегментах на заказ багажа со скидкой, превышающий доступное количество в подписке
            // поиск происходит параметрам `airline_svc.code` и `airline_svc.type`
            that.smartup_luggage_max_quantity = {
                code_mask: 'LUGGAGE_SMARTUP_23KG_203CM',
                type: 'LUGGAGE'
            };

            // DYNAMIC VARS
            that.luggage_selected_unpaid = [];
            that.luggage_selected_paid = that.options['items_paid'] || [];
            that.luggage_total = that.options['total'] || 0;
            that.luggage_additional_empty_warning_disallow = false;

            that.is_showed = false;

            // HANDLERS
            that.onPassengerSelected = (that.options['onPassengerSelected'] || function () {});
            that.onPassengerReset = (that.options['onPassengerReset'] || function () {});
            that.onButtonConfirmClick = (that.options['onButtonConfirmClick'] || function () {});
            that.onButtonCancelClick = (that.options['onButtonCancelClick'] || function () {});
            that.onLuggageIncompleteWarningCancelClosed = (that.options['onLuggageIncompleteWarningCancelClosed'] || function () {});
            that.onLuggageAdditionalEmptyWarningCancelClosed = (that.options['onLuggageAdditionalEmptyWarningCancelClosed'] || function () {});

            // COMPONENTS
            // key - svc_id, value - UISelectSegmentPassengers[]
            that.select_segment_passengers_desktop = {};
            // key - svc_id, value - UISelectSegmentPassengers[]
            that.select_segment_passengers_mobile = {};

            //ANALYTICS
            /** @type {AnalyticsSvcsDataset} */
            that.analytics_dataset = that.options.analytics_dataset || null;

            // INIT
            that.init();
        }
    }

    SvcsScreenLuggage.prototype.init = function () {
        var that = this;

        // HAS TO BE CALLED BEFORE initSelectSegmentPassengersDesktop(), OTHERWISE IT WILL OVERRIDE BADGES SET AFTER SELECT
        // hide badge 'Added' for all svcs
        that.__svcAirlineSvcBadgeToggle('added', false);
        //
        // HAS TO BE CALLED BEFORE initSelectSegmentPassengersDesktop(), OTHERWISE IT WILL OVERRIDE ACTION STATE SET AFTER SELECT
        // set action button state empty
        that.__svcAirlineSetActionStateAdd();
        //
        // hide badge 'Paid' for all svcs
        that.__svcAirlineSvcBadgeToggle('paid', false);
        //
        that.showInitialSvcsPaid();
        //
        that.initSelectSegmentPassengersDesktop(
            that.$wrapper.find(that.selectors.select_segment_passengers),
            that.options['items_unpaid'] || []
        );
        //
        that.svcActionHandlers();
        //
        that.svcAirlineFilter();
        //
        that.svcLuggageTotalDrawerInit();
        //
        that.svcActionSubmitHandler();
        //
        that.svcLuggageTotalSideContentInit();
        //
        that.__svcAirlineToggleHintPosition();
        //
        if (that.screen_mode === 'drawer') {
            // Set submit button text
            // (must be after initSelectSegmentPassengersDesktop(), because here we're going to override the text,
            // which was set on select during the SelectSegmentPassengers initialization)
            that.__setInitialSubmitActionState();
            //
            that.__analyticsEmitViewItemListEvent();
        }
        //
        that.__displayTotal();
    };

    SvcsScreenLuggage.prototype.__setInitialSubmitActionState = function () {
        var that = this;
        // if there were any unpaid items on init - set Confirm state
        if (that.items_unpaid_initial_count > 0) {
            that.__setActionSubmitConfirm();
        }
        // if there were no unpaid items, but there are any paid items - set Continue state
        else if (that.luggage_selected_paid && that.luggage_selected_paid.length) {
            that.__setActionSubmitContinue();
        }
        // if there were no unpaid items on init, and no paid items - set Empty state
        else {
            that.__setActionSubmitEmpty();
        }
    };

    SvcsScreenLuggage.prototype.showInitialSvcsPaid = function () {
        var that = this,
            svcs_quantities = {};

        // collect quantities of all svcs
        for (var i = 0; i < that.luggage_selected_paid.length; i++) {
            var item_id = that.luggage_selected_paid[i]['item_id'];

            if (svcs_quantities.hasOwnProperty(item_id)) {
                continue;
            }

            svcs_quantities[item_id] = that.luggage_selected_paid.reduce(function (qty, current) {
                if (current['item_id'].toString() === item_id.toString()) {
                    return qty + parseInt(current['item_quantity'], 10);
                } else {
                    return qty;
                }
            }, 0);
        }

        for (var svc_id in svcs_quantities) {
            that.__svcAirlineSvcBadgeSetQuantity('paid', svc_id, svcs_quantities[svc_id]);
            that.__svcAirlineSvcBadgeToggle('paid', !!svcs_quantities[svc_id], svc_id);
        }
    };

    SvcsScreenLuggage.prototype.svcActionSubmitHandler = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.svc_action_submit);

        $action.on('click', function (event) {
            var $this = $(this);

            if ($this.hasClass(that.class.svc_action_confirm)) {
                that.onButtonConfirmClick(that.luggage_selected_unpaid, that, event);
            } else if ($this.hasClass(that.class.svc_action_cancel)) {
                that.onButtonCancelClick(that.luggage_selected_unpaid, that, event);
            }
        });
    };

    SvcsScreenLuggage.prototype.svcActionHandlers = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.svc_action);

        $.sa.$window.on('resize', function (e) {
            var $svc_content = that.$wrapper.find('.' + that.class.svc_content);

            if (!$.sa.is_desktop()) {
                // collapse card if it's expanded
                if (UIToggle.prototype.isActive($svc_content)) {
                    UIToggle.prototype.toggleTrigger($svc_content);
                }
            }
        });

        // SELECT SVC ON TOGGLE CARD BUTTON CLICK (https://tracker.flysa.ru/browse/SMA-2290)
        // THIS MUST BE BEFORE DEFAULT CALLBACK - FOR CORRECT WORK OF MOBILE VERSION
        $action.on('click', function (e) {
            var $this = $(this),
                $svc_card = $this.parents('.' + that.class.svc_luggage_wrapper),
                $svc_content = $svc_card.find('.' + that.class.svc_content),
                svc_id = $svc_card.data('airline-svc-id');

            // apply select only on expand
            if (UIToggle.prototype.isActive($svc_content)) {
                return;
            }

            // if svc is already selected, or force select was already performed on this svc
            if (that.luggage_selected_unpaid.some(selection => (
                    selection.item_id.toString() === svc_id.toString() &&
                    (
                        parseInt(selection.item_quantity, 10) > 0 ||
                        selection.force_select
                    )
                ))
            ) {
                return;
            }

            // if svc is already paid
            if (that.luggage_selected_paid && that.luggage_selected_paid.some(selection => (
                    selection.item_id.toString() === svc_id.toString()
                ))
            ) {
                return;
            }

            // filter svc_select_segment_passengers - only one on each direction_index
            var svc_select_segment_passengers = that.__getSvcsSelectSegmentPassengersOneForDirection([svc_id]);

            // loop for all segments
            for (var key in svc_select_segment_passengers) {
                var select_segment_passengers = svc_select_segment_passengers[key],
                    $passengers = select_segment_passengers.getSegmentPassengersAll();

                $passengers.each(function () {
                    var $passenger = $(this),
                        svc_passenger_id = select_segment_passengers.getPassengerId($passenger),
                        svc_price = select_segment_passengers.getPassengerSelectionPrice($passenger),
                        svc_quantity = 1;

                    // if it's counter - add min counter value to quantity
                    if (select_segment_passengers.isType(select_segment_passengers.TYPES.counter)) {
                        var min_value = select_segment_passengers.getPassengerCounterMin(svc_passenger_id);
                        svc_quantity += min_value;
                    }

                    if (svc_passenger_id) {
                        select_segment_passengers.select(
                            svc_passenger_id,
                            svc_id,
                            svc_price,
                            {
                                is_segment_transfer: !!select_segment_passengers.isSegmentTransfer(),
                                force_select: true
                            },
                            svc_quantity,
                            1
                        );
                    }
                });
            }
        });

        $action.on('click', function (e) {
            e.preventDefault();
            var $this = $(this),
                $parent = $this.parents('.' + that.class.svc_luggage_wrapper),
                $parent_border = $parent.find('.' + that.class.svc_border);

            if ($.sa.is_desktop()) {
                // add '.sticky' only when svc card is expanded to fix bottom hints
                $parent_border.toggleClass('sticky', ($this.hasClass(that.class.svc_action_add) || $this.hasClass(that.class.svc_action_edit)));

                that.__scrollToToggle($this, $parent);
            } else {
                that.__renderSvcPassengerSegmentDrawer($this, $parent);
            }

            if (that.analytics_dataset && that.analytics_dataset.layout === 'main') {
                var svc_id = $parent.data('airline-svc-id');
                if (svc_id) {
                    var event_data = that.analytics_dataset.getViewItemListForSingleSvc(svc_id);
                    if (event_data) {
                        $.sa.analytics.gtag('event', 'view_item_list', event_data);
                    }
                }
            }
        });
    };

    SvcsScreenLuggage.prototype.__scrollToToggle = function ($action, $node) {
        var that = this,
            $pills_wrapper = that.$wrapper.find('.' + that.class.pills_wrapper),
            sticky_offset = 0,
            svcs_luggage_wrapper_gap = 16, // gap between cards from figma
            scroll_timeout = 20, // should be  more than default toggle duration time (10)
            transition = 300; // default transition time

        // if we have sticky panel
        if ($pills_wrapper.hasClass('sticky')) {
            sticky_offset = $pills_wrapper.outerHeight(true) + svcs_luggage_wrapper_gap;
        }

        // if changed toggle duration
        if ($action.data('toggle-duration')) {
            scroll_timeout = $action.data('toggle-duration') + 10; // should be  more than default toggle duration time
        }

        setTimeout(function () {
            if (that.screen_mode === 'screen') {
                $.sa.scrollToNode($node, transition, -sticky_offset);
            }
            if (that.screen_mode === 'drawer') {
                var $drawer_scroll_content = that.$wrapper.find('.drawer-content.scrollbar.scroll-content'),
                    drawer_content_padding_top = 16, // 16px gap vertical
                    node_position = $node.offset().top -
                        that.$wrapper.find('.drawer-header').outerHeight(true) -
                        that.$wrapper.find('.drawer-content-fixed').outerHeight(true) +
                        $drawer_scroll_content.scrollTop() -
                        drawer_content_padding_top -
                        $.sa.$document.scrollTop();

                that.$wrapper.find('.drawer-content.scrollbar.scroll-content').animate({
                    scrollTop: node_position
                }, transition);
            }
        }, scroll_timeout);
    };

    SvcsScreenLuggage.prototype.__renderSvcPassengerSegmentDrawer = function ($action, $parent) {
        var that = this,
            $title = $parent.find('.' + that.class.svc_title).clone(),
            $sub_title = $parent.find('.' + that.class.svc_sub_title).clone(),
            $content_wrapper = $parent.find('.' + that.class.svc_content),
            $luggage_wrapper = $content_wrapper.parents('.' + that.class.svc_luggage_wrapper),
            content = $content_wrapper.html(),
            footer = `<button class="button primary width-1-1 js-button-confirm">${$.sa.locales['confirm']}</button>`,
            airline_svc_id = $parent.data('airline-svc-id'),
            svc_segment_quantity_initial = that.__getLuggageQuantity(airline_svc_id),
            svc_info = {
                svc_code: $luggage_wrapper.data('svc-code'),
                svc_type: $luggage_wrapper.data('svc-type'),
                svc_max_quantity: $luggage_wrapper.data('svc-max-quantity'),
                svc_available_quantity: $luggage_wrapper.data('svc-available-quantity')
            };

        $.uiDrawer({
            position: 'bottom',
            header_title: $title,
            header_description: $sub_title,
            header_contrast: true,
            content: content,
            custom_class: 'svcs',
            footer: footer,
            onOpen: function ($drawer_wrapper, drawer) {
                var $select_segment_passengers = $drawer_wrapper.find(that.selectors.select_segment_passengers),
                    $submit_button_drawer = $drawer_wrapper.find('.js-button-confirm'),
                    // if there are any selected items on drawer open - set Confirm state, otherwise - set Empty state
                    submit_button_state_initial = (svc_segment_quantity_initial > 0) ? 'confirm' : 'empty';

                that.initSelectSegmentPassengersMobile(
                    $select_segment_passengers,
                    airline_svc_id,
                    $drawer_wrapper,
                    $submit_button_drawer,
                    svc_segment_quantity_initial,
                    submit_button_state_initial,
                    svc_info
                );
                that.__setSegmentDrawerActionSubmitState(submit_button_state_initial, $submit_button_drawer);
            },
            onClose: function (drawer) {
                that.clearSelectSegmentPassengersMobile();
            }
        });
    };

    SvcsScreenLuggage.prototype.svcAirlineFilter = function () {
        var that = this,
            $svc_airline_category = that.$wrapper.find('.' + that.class.svc_airline_category);

        $svc_airline_category.on('click', function (e) {
            e.preventDefault();

            var $button = $(this),
                $button_wrapper = $button.parents('.' + that.class.svc_airline_categories),
                category_id = $button.data('id');

            that.__svcAirlineFilterChangeButtonState($button_wrapper, $button);
            that.__svcAirlineFilterToggleWrapper(category_id);
            that.__svcAirlineToggleHintPosition(category_id);
        });
    };

    SvcsScreenLuggage.prototype.__svcAirlineFilterChangeButtonState = function ($button_wrapper, $button) {
        var that = this;

        $button_wrapper.find('.' + that.class.svc_airline_category).removeClass(that.class.is_active);
        $button.addClass(that.class.is_active);
    };

    /**
     * Обработка кликов по категориям дополнительного багажа
     *
     * @param {String|Number} category_id ID категории багажа
     * @private
     */
    SvcsScreenLuggage.prototype.__svcAirlineFilterToggleWrapper = function (category_id) {
        var that = this;

        if (category_id !== 'all') {
            that.$wrapper.find('.' + that.class.svc_luggage_wrapper).hide();
            that.$wrapper.find('.' + that.class.svc_luggage_wrapper + '[data-category-id="' + category_id + '"]')
                .fadeIn();
        } else {
            that.$wrapper.find('.' + that.class.svc_luggage_wrapper)
                .fadeIn();
        }

        that.__analyticsEmitViewItemListEvent(category_id);
    };

    /**
     * @param {string|int} category_id
     * @private
     */
    SvcsScreenLuggage.prototype.__analyticsEmitViewItemListEvent = function (category_id = 'all') {
        var that = this, event_data;

        if (that.analytics_dataset && that.analytics_dataset.layout === 'svc_add') {
            that.analytics_dataset.LUGGAGE_TYPES.forEach(type => {
                event_data = that.analytics_dataset.getViewItemListForType(type, 0, category_id);
                if (event_data) {
                    $.sa.analytics.gtag('event', 'view_item_list', event_data);
                }
            });
        }
    }

    SvcsScreenLuggage.prototype.onShow = function () {
        var that = this;

        if (that.analytics_dataset && that.analytics_dataset.layout === 'main') {
            $.sa.analytics.gtagSelectContent('page', 'main_luggage_svcs');
        }

        // if there are initially default items,
        // they are shown only on Screen open event (onShow)
        if (!that.is_showed && that.options['items_default'] && that.options['items_default'].length) {
            that.applySelectOn(that.options['items_default']);
        }

        that.is_showed = true;
    }

    SvcsScreenLuggage.prototype.__svcAirlineToggleHintPosition = function (category_id = 'all') {
        var that = this,
            svcs_selector = (category_id !== 'all')
                ? '.' + that.class.svc_luggage_wrapper + '[data-category-id="' + category_id + '"]'
                : '.' + that.class.svc_luggage_wrapper,
            $svcs = that.$wrapper.find(svcs_selector),
            $svc_first = $svcs.first(),
            $svc_others = $svc_first.siblings(svcs_selector),
            $svc_first_hint = $svc_first.find('.' + that.class.svc_hint),
            $svc_others_hint = $svc_others.find('.' + that.class.svc_hint);

        if ($svc_first_hint.length) {
            $svc_first_hint.removeClass(that.class.svc_hint_top);
        }
        $svc_others_hint.addClass(that.class.svc_hint_top);
    };

    /**
     * Toggle (show or hide) badge 'Added' for specified svc, depending on specified state
     * @param {String} type Type of badge
     * @param {Boolean} state Show or hide badge
     * @param {String|int|null} airline_svc_id If not specified - toggle badges for all svcs
     * @private
     */
    SvcsScreenLuggage.prototype.__svcAirlineSvcBadgeToggle = function (type, state, airline_svc_id = null) {
        var that = this,
            $svc = airline_svc_id
                ? that.$wrapper.find('.' + that.class.svc_luggage_wrapper + '[data-airline-svc-id="' + airline_svc_id + '"]')
                : that.$wrapper.find('.' + that.class.svc_luggage_wrapper),
            badge_class = that.class['svc_badge_' + type],
            $svc_badge = $svc.find('.' + badge_class);
        $svc_badge.toggle(state);
    };

    SvcsScreenLuggage.prototype.__svcAirlineSvcBadgeSetQuantity = function (type, airline_svc_id, quantity = 0) {
        var that = this,
            $svc = that.$wrapper.find('.' + that.class.svc_luggage_wrapper + '[data-airline-svc-id="' + airline_svc_id + '"]'),
            badge_class = that.class['svc_badge_' + type],
            badge_quantity_class = that.class['svc_badge_' + type + '_quantity'],
            $svc_badge = $svc.find('.' + badge_class),
            $svc_badge_quantity = $svc_badge.find('.' + badge_quantity_class);

        if (!quantity) {
            $svc_badge_quantity.hide();
        } else {
            $svc_badge_quantity.text('x' + quantity).show();
        }
    };

    SvcsScreenLuggage.prototype.__svcAirlineSetActionStateAdd = function (airline_svc_id = null) {
        var that = this,
            $svc = airline_svc_id
                ? that.$wrapper.find('.' + that.class.svc_luggage_wrapper + '[data-airline-svc-id="' + airline_svc_id + '"]')
                : that.$wrapper.find('.' + that.class.svc_luggage_wrapper),
            $svc_action_edit = $svc.find('.' + that.class.svc_action_edit),
            $svc_action_add = $svc.find('.' + that.class.svc_action_add);

        $svc_action_edit.hide();
        $svc_action_add.show();
    };

    SvcsScreenLuggage.prototype.__svcAirlineSetActionStateEdit = function (airline_svc_id) {
        var that = this,
            $svc = that.$wrapper.find('.' + that.class.svc_luggage_wrapper + '[data-airline-svc-id="' + airline_svc_id + '"]'),
            $svc_action_edit = $svc.find('.' + that.class.svc_action_edit),
            $svc_action_add = $svc.find('.' + that.class.svc_action_add);

        $svc_action_add.hide();
        $svc_action_edit.show();
    };

    SvcsScreenLuggage.prototype.svcLuggageTotalDrawerInit = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.svcs_luggage_total_drawer_call);

        $action.on('click', function (e) {
            e.preventDefault();

            var content = that.$wrapper.find('.' + that.class.svcs_luggage_total_content).html(),
                title = $action.data('title');

            $.uiDrawer({
                position: 'bottom',
                header_title: title,
                content: content,
                custom_class: 'svcs',
                fluid: true,
                disable_content_scroll: true,
                onOpen($wrapper) {
                    $('.js-luggage-rules-link', $wrapper)
                        .off('.analytics')
                        .on('click.analytics', function () {
                            $.sa.analytics.gtagSelectContent('reference', 'svcs_rules_for_baggage_and_carry-on_baggage');
                            return true;
                        });
                }
            });
        });
    };

    /**
     * Генерация события аналитики при клике на ссылку просмотре правил провоза багажа
     */
    SvcsScreenLuggage.prototype.svcLuggageTotalSideContentInit = function () {
        const that = this;
        $('.' + that.class.svcs_luggage_total_content)
            .find(that.selectors.luggage_rules_link)
            .off('.analytics')
            .on('click.analytics', function () {
                $.sa.analytics.gtagSelectContent('reference', 'svcs_rules_for_baggage_and_carry-on_baggage');
                return true;
            });
    }

    /**
     * Вызывается из колбеков после увеличения и уменьшения количества услуг
     *
     * @param {SegmentChangesItem|SegmentChangesItem[]} data
     * @param {UISelectSegmentPassengers} component
     * @private
     */
    SvcsScreenLuggage.prototype.__analyticsEventOnCartChange = function (data, component) {
        var that = this;

        if(!that.analytics_dataset || that.analytics_dataset.layout !== 'main') {
            return;
        }

        var cart_change = that.analytics_dataset.svcCartChange(data, component);

        if (cart_change.add_to_cart) {
            $.sa.analytics.gtag('event', 'add_to_cart', cart_change.add_to_cart);
        }

        if (cart_change.remove_from_cart) {
            $.sa.analytics.gtag('event', 'remove_from_cart', cart_change.remove_from_cart);
        }
    }

    SvcsScreenLuggage.prototype.initSelectSegmentPassengersDesktop = function (
        $select_segment_passengers,
        selected_items_unpaid = []
    ) {
        var that = this,
            options;

        options = {
            collapse_on_select_all: false,
            // do not pass unpaid items - we would apply them later, after all UISelectSegmentPassengers init
            items_paid: that.luggage_selected_paid,
            /**
             * @param {SegmentChangesItem|SegmentChangesItem[]} data
             * @param {UISelectSegmentPassengers} component
             */
            onPassengerSelected: function (data, component) {
                if (Array.isArray(data)) {
                    data.forEach(function (data_item) {
                        that.__onLuggageSelect(data_item);
                    });
                } else {
                    that.__onLuggageSelect(data);
                }
                that.__showSvcSegmentQtyTotal();

                if (that.screen_mode === 'drawer') {
                    // Update submit button state
                    var quantity = that.__getLuggageQuantityAll();
                    // if quantity was set to initial value - set initial state
                    if (quantity === that.items_unpaid_initial_count) {
                        that.__setInitialSubmitActionState();
                    }
                    // if current quantity is lesser than initial one - set Confirm state
                    else if (quantity < that.items_unpaid_initial_count) {
                        that.__setActionSubmitConfirm();
                    }
                    // if current quantity is greater than initial one - set Add state
                    else {
                        that.__setActionSubmitAdd();
                    }
                }

                that.__analyticsEventOnCartChange(data, component);
            },
            /**
             * @param {SegmentChangesItem|SegmentChangesItem[]} data
             * @param {UISelectSegmentPassengers} component
             */
            afterPassengerSelected: function (data, component) {
                var direction_index = component.getSegmentDirectionIndex();

                if (Array.isArray(data)) {
                    data.forEach(function (data_item) {
                        that.__applySelectOnOtherDirectionSegments(data_item, direction_index, 'desktop');
                    });
                } else {
                    that.__applySelectOnOtherDirectionSegments(data, direction_index, 'desktop');
                }
            },
            onPassengerReset: function (data, call_callback_after, component) {
                if (Array.isArray(data)) {
                    data.forEach(function (data_item) {
                        that.__onLuggageReset(data_item);
                    });
                } else {
                    that.__onLuggageReset(data);
                }
                that.__showSvcSegmentQtyTotal();

                if (that.screen_mode === 'drawer') {
                    var quantity = that.__getLuggageQuantityAll();
                    // Update submit button state
                    if (quantity === 0) {
                        if (that.luggage_selected_paid && that.luggage_selected_paid.length) {
                            that.__setActionSubmitConfirm();
                        } else {
                            that.__setActionSubmitEmpty();
                        }
                    }
                    // if quantity was dropped to initial value - set initial state
                    else if (quantity === that.items_unpaid_initial_count) {
                        that.__setInitialSubmitActionState();
                    }
                    // if quantity was dropped, but current quantity is still greater than initial one - set Add state
                    else if (quantity > that.items_unpaid_initial_count) {
                        that.__setActionSubmitAdd();
                    }
                    // if quantity was dropped, and current quantity is lesser than initial one - set Confirm state
                    else {
                        that.__setActionSubmitConfirm();
                    }
                }

                that.__analyticsEventOnCartChange(data, component);
            },
            /**
             * @param {SegmentChangesItem|SegmentChangesItem[]} data
             * @param {UISelectSegmentPassengers} component
             */
            afterPassengerReset: function (data, component) {
                var direction_index = component.getSegmentDirectionIndex();

                if (Array.isArray(data)) {
                    data.forEach(function (data_item) {
                        that.__applyResetOnOtherDirectionSegments(data_item, direction_index, 'desktop');
                    });
                } else {
                    that.__applyResetOnOtherDirectionSegments(data, direction_index, 'desktop');
                }
            }
        };

        $select_segment_passengers.each(function () {
            var $luggage_wrapper = $(this).parents('.' + that.class.svc_luggage_wrapper),
                $luggage_content = $luggage_wrapper.find('.' + that.class.svc_content),
                airline_svc_id = $luggage_wrapper.data('airline-svc-id'),
                svc_info = {
                    svc_code: $luggage_wrapper.data('svc-code'),
                    svc_type: $luggage_wrapper.data('svc-type'),
                    svc_max_quantity: $luggage_wrapper.data('svc-max-quantity'),
                    svc_available_quantity: $luggage_wrapper.data('svc-available-quantity')
                };

            if (!that.select_segment_passengers_desktop.hasOwnProperty(airline_svc_id) || !Array.isArray(that.select_segment_passengers_desktop[airline_svc_id])) {
                that.select_segment_passengers_desktop[airline_svc_id] = [];
            }

            that.select_segment_passengers_desktop[airline_svc_id].push(
                new UISelectSegmentPassengers(Object.assign({}, options, {
                    $wrapper: $(this),
                    $container: $luggage_content,
                    params: svc_info
                }))
            );
        });

        that.luggage_selected_paid.forEach(function (selection) {
            // check pets in cabin considering paid items
            that.__checkPetCabinQuantity(selection);

            // check that the smartup luggage does not exceed the available quantity
            that.__checkRemainingSmartupLuggageQuantity(selection);
        });

        // after all UISelectSegmentPassengers init - apply unpaid items;
        // because __applySelectOnOtherDirectionSegments() could be not applied after unpaid item initial selection -
        // because UISelectSegmentPassengers for other direction segments might be not initialized yet

        that.applySelectOn(selected_items_unpaid);
    };


    SvcsScreenLuggage.prototype.initSelectSegmentPassengersMobile = function (
        $select_segment_passengers,
        airline_svc_id,
        $container,
        $submit_button,
        quantity_initial,
        submit_button_state_initial,
        params = null
    ) {
        var that = this,
            options;

        options = {
            $container: $container,
            select_on_init: false,
            collapse_on_select_all: false,
            onPassengerSelected: function (data, component) {
                // apply select on desktop Passengers Selectors
                var applyOnDesktop = function (data, segment_id) {
                    var luggage_selections = that.select_segment_passengers_desktop[data.item_id];
                    luggage_selections.forEach(function (select_segment_passengers) {
                        if (select_segment_passengers.isThatSegment(segment_id)) {
                            var selected_quantity = parseInt(data['item_quantity'], 10),
                                // if it's counter - add min counter value to quantity
                                quantity = select_segment_passengers.isType(select_segment_passengers.TYPES.counter)
                                    ? selected_quantity + select_segment_passengers.getPassengerCounterMin(data['passenger_id'])
                                    : selected_quantity;

                            select_segment_passengers.select(
                                data['passenger_id'],
                                data['item_id'],
                                data['item_price'],
                                {
                                    item_text: data['item_text'],
                                    is_segment_transfer: !!select_segment_passengers.isSegmentTransfer()
                                },
                                quantity,
                                data['item_quantity_diff']
                            );
                        }
                    });
                };

                if (!Array.isArray(data)) {
                    applyOnDesktop(data, data.segment_id);
                } else {
                    data.forEach(function (data_item) {
                        // need to pass exactly component's segment_id IMPORTANT
                        applyOnDesktop(data_item, component.segment_id);
                    });
                }

                var quantity = that.__getLuggageQuantity(airline_svc_id);
                // Update submit button state
                if (quantity === quantity_initial) {
                    that.__setSegmentDrawerActionSubmitState(submit_button_state_initial, $submit_button);
                } else if (quantity < quantity_initial) {
                    that.__setSegmentDrawerActionSubmitState('confirm', $submit_button);
                } else {
                    that.__setSegmentDrawerActionSubmitState('added', $submit_button);
                }
            },
            afterPassengerSelected: function (data, component) {
                var direction_index = component.getSegmentDirectionIndex();

                // don't need to apply on desktop - it was done on select()
                if (Array.isArray(data)) {
                    data.forEach(function (data_item) {
                        that.__applySelectOnOtherDirectionSegments(data_item, direction_index, 'mobile', false);
                    });
                } else {
                    that.__applySelectOnOtherDirectionSegments(data, direction_index, 'mobile', false);
                }

                that.__analyticsEventOnCartChange(data, component);
            },
            onPassengerReset: function (data, call_callback_after, component) {
                // apply reset on desktop Passengers Selectors
                var applyOnDesktop = function (data, segment_id, passenger_id) {
                    var luggage_selections = that.select_segment_passengers_desktop[data.item_id];
                    luggage_selections.forEach(function (select_segment_passengers) {
                        if (select_segment_passengers.isThatSegment(segment_id)) {
                            var $passenger = select_segment_passengers.getPassengerById(passenger_id),
                                $selection = select_segment_passengers.getPassengerSelection($passenger);
                            select_segment_passengers.reset($selection, call_callback_after);
                        }
                    });
                }

                if (!Array.isArray(data)) {
                    applyOnDesktop(data, data.segment_id, data.passenger_id);
                } else {
                    applyOnDesktop(data, component.segment_id, data.passenger_id);
                }

                var quantity = that.__getLuggageQuantity(airline_svc_id);
                // Update submit button state
                if (quantity === 0) {
                    that.__setSegmentDrawerActionSubmitState('empty', $submit_button);
                } else if (quantity === quantity_initial) {
                    that.__setSegmentDrawerActionSubmitState(submit_button_state_initial, $submit_button);
                } else if (quantity > quantity_initial) {
                    that.__setSegmentDrawerActionSubmitState('added', $submit_button);
                } else {
                    that.__setSegmentDrawerActionSubmitState('confirm', $submit_button);
                }
            },
            afterPassengerReset: function (data, component) {
                var direction_index = component.getSegmentDirectionIndex();

                // don't need to apply on desktop - it was done on reset()
                if (Array.isArray(data)) {
                    data.forEach(function (data_item) {
                        that.__applyResetOnOtherDirectionSegments(data_item, direction_index, 'mobile', false);
                    });
                } else {
                    that.__applyResetOnOtherDirectionSegments(data, direction_index, 'mobile', false);
                }
                that.__analyticsEventOnCartChange(data, component);
            }
        };

        if ($select_segment_passengers.length) {
            if (!that.select_segment_passengers_mobile.hasOwnProperty(airline_svc_id) || !Array.isArray(that.select_segment_passengers_mobile[airline_svc_id])) {
                that.select_segment_passengers_mobile[airline_svc_id] = [];
            }
            $select_segment_passengers.each(function () {
                that.select_segment_passengers_mobile[airline_svc_id].push(
                    new UISelectSegmentPassengers(Object.assign({}, options, {$wrapper: $(this), params: params}))
                );
            });
        }
    };

    SvcsScreenLuggage.prototype.clearSelectSegmentPassengersMobile = function () {
        var that = this;
        that.select_segment_passengers_mobile = {};
    };

    SvcsScreenLuggage.prototype.__onLuggageSelect = function (data) {
        var that = this,
            price = data.item_price ? parseFloat(data.item_price) : 0,
            quantity_diff = data.item_quantity_diff ? parseInt(data.item_quantity_diff, 10) : 0,
            quantity;

        if (0 !== quantity_diff) {
            // Save collection for reopened drawer
            that.__saveSvc(data);

            that.__changeTotal(price, quantity_diff);
            that.__displayTotal();

            // callback from parent
            that.onPassengerSelected(data, that);

            // toggle badge 'Added'
            // get new luggage quantity after update
            quantity = that.__getLuggageQuantity(data.item_id);
            that.__svcAirlineSvcBadgeSetQuantity('added', data.item_id, quantity);
            that.__svcAirlineSvcBadgeToggle('added', !!quantity, data.item_id);
            // change action button
            that.__svcAirlineSetActionStateEdit(data.item_id);

            that.__checkPetCabinQuantity(data);
            that.__checkRemainingSmartupLuggageQuantity(data);
        }
    };

    SvcsScreenLuggage.prototype.__onLuggageReset = function (data) {
        var that = this,
            price = data.item_price ? parseFloat(data.item_price) : 0,
            quantity_diff = data.item_quantity_diff ? parseInt(data.item_quantity_diff, 10) : 0,
            quantity = that.__getLuggageQuantity(data.item_id); // get quantity at the start - IMPORTANT

        if (0 !== quantity_diff) {
            // Reset collection for reopened drawer
            that.__resetSvc(data);

            that.__changeTotal(price, quantity_diff);
            that.__displayTotal();

            // callback from parent
            that.onPassengerReset(data, that);

            // toggle badge 'Added'
            // if svc was fully removed
            if (quantity <= Math.abs(quantity_diff)) {
                that.__svcAirlineSvcBadgeToggle('added', false, data.item_id);
                // change action button
                that.__svcAirlineSetActionStateAdd(data.item_id);
            }
            // or if it's just quantity reduced
            else {
                // get new luggage quantity after update
                quantity = that.__getLuggageQuantity(data.item_id);
                that.__svcAirlineSvcBadgeSetQuantity('added', data.item_id, quantity);
                that.__svcAirlineSvcBadgeToggle('added', true, data.item_id);
                // change action button
                that.__svcAirlineSetActionStateEdit(data.item_id);
            }

            that.__checkPetCabinQuantity(data);
            that.__checkRemainingSmartupLuggageQuantity(data);
        }
    };

    SvcsScreenLuggage.prototype.__saveSvc = function (data) {
        var that = this,
            item_changed_index = that.luggage_selected_unpaid.length ? that.luggage_selected_unpaid.findIndex(selection => (
                    selection.segment_id.toString()   === data.segment_id.toString() &&
                    selection.passenger_id.toString() === data.passenger_id.toString() &&
                    selection.item_id.toString()      === data.item_id.toString()
                )
            ) : -1,
            quantity = parseInt(data.item_quantity, 10),
            quantity_diff = parseInt(data.item_quantity_diff, 10);

        // if item is already saved, update quantity
        if (item_changed_index !== -1) {
            that.luggage_selected_unpaid[item_changed_index]['item_quantity'] = quantity;
            that.luggage_selected_unpaid[item_changed_index]['item_quantity_diff'] = quantity_diff;

            // SELECT SVC ON TOGGLE CARD BUTTON CLICK (https://tracker.flysa.ru/browse/SMA-2290)
            if (data.hasOwnProperty('force_select')) {
                that.luggage_selected_unpaid[item_changed_index]['force_select'] = data.force_select;
            }
        } else {
            that.luggage_selected_unpaid.push(data);
        }
    };

    SvcsScreenLuggage.prototype.__resetSvc = function (data) {
        var that = this,
            item_changed_index = that.luggage_selected_unpaid.findIndex(selection => (
                    selection.segment_id.toString()   === data.segment_id.toString() &&
                    selection.passenger_id.toString() === data.passenger_id.toString() &&
                    selection.item_id.toString()      === data.item_id.toString()
                )
            ),
            quantity = parseInt(data.item_quantity, 10),
            quantity_diff = parseInt(data.item_quantity_diff, 10);

        // remove item
        if (item_changed_index === -1) {
            $.sa.log('Error reset luggage: not exists in set of selections');
            return;
        }

        that.luggage_selected_unpaid[item_changed_index]['item_quantity'] = quantity;
        that.luggage_selected_unpaid[item_changed_index]['item_quantity_diff'] = quantity_diff;
    };

    /**
     * Отфильтровать список услуг по пассажиро-сегментно, который "связан" (по svc_type и маске параметра `svc-code`) с текущей выбранной услугой
     * @param data Текущая добавленная услуга
     * @param all_select_segment_passengers
     * @param svc_type
     * @param svc_code_mask
     * @returns {*[]}
     * @private
     */
    SvcsScreenLuggage.prototype.__getRelatedSelectSegmentPassengersSvcs = function (data, all_select_segment_passengers, svc_type, svc_code_mask) {
        var that = this,
            related_select_segment_passengers = [];

        for (var airline_svc_id in all_select_segment_passengers) {
            all_select_segment_passengers[airline_svc_id].forEach(function (select_segment_passengers) {
                if (!select_segment_passengers.isThatSegment(data['segment_id'])) {
                    return;
                }

                var params_svc_info = select_segment_passengers.getParams();
                if (!params_svc_info) {
                    return;
                }

                if (
                    params_svc_info['svc_type'] !== svc_type ||
                    params_svc_info['svc_code'].indexOf(svc_code_mask) === -1
                ) {
                    return;
                }

                related_select_segment_passengers.push(select_segment_passengers);
            });
        }
        return related_select_segment_passengers;
    };

    /**
     * Выбрать весь список пассажиро-сегментнов, которые связаны с текущей выбранной услугой
     * @param svc_id
     * @param all_select_segment_passengers
     * @param svc_type
     * @param svc_code_mask
     * @returns {*[]}
     * @private
     */
    SvcsScreenLuggage.prototype.__getAllSegmentsByParams = function (svc_id, all_select_segment_passengers, svc_type, svc_code_mask) {
        var that = this,
            related_select_segment_passengers = [],
            segments = all_select_segment_passengers[svc_id] || [];

        segments.forEach(function (select_segment_passengers) {
            var params_svc_info = select_segment_passengers.getParams();
            if (!params_svc_info) {
                return;
            }

            if (
                params_svc_info['svc_type'] !== svc_type ||
                params_svc_info['svc_code'].indexOf(svc_code_mask) === -1
            ) {
                return;
            }

            related_select_segment_passengers.push(select_segment_passengers);
        });

        return related_select_segment_passengers;
    };

    /**
     * Задать новое значение для аттрибута `max`
     * @param related_select_segment_passengers
     * @param data
     * @param current_quantity
     * @private
     */
    SvcsScreenLuggage.prototype.__setPetCabinMaxQuantity = function (related_select_segment_passengers, data, current_quantity) {
        var that = this;

        related_select_segment_passengers.forEach(function (select_segment_passengers) {
            var max_quantity = null;
            if (current_quantity < that.pet_cabin_max_quantity.max_quantity) {
                max_quantity = select_segment_passengers['params']['svc_max_quantity'];
            }
            select_segment_passengers.setPassengerCounterMax(data.passenger_id, max_quantity);
        });
    };

    /**
     * Проверить не превышены ли общие лимиты у "связанных" услуг с текущей добавленной услугой
     * @param data
     * @private
     */
    SvcsScreenLuggage.prototype.__checkPetCabinQuantity = function (data) {
        var that = this,
            current_quantity = 0,
            related_select_segment_passengers_svcs_desktop = that.__getRelatedSelectSegmentPassengersSvcs(data, that.select_segment_passengers_desktop, that.pet_cabin_max_quantity['type'], that.pet_cabin_max_quantity['code_mask']),
            related_select_segment_passengers_svcs_mobile = that.__getRelatedSelectSegmentPassengersSvcs(data, that.select_segment_passengers_mobile, that.pet_cabin_max_quantity['type'], that.pet_cabin_max_quantity['code_mask']);

        related_select_segment_passengers_svcs_desktop.forEach(function (select_segment_passengers) {
            var $passenger = select_segment_passengers.getPassengerById(data['passenger_id']);
            current_quantity += select_segment_passengers.getPassengerQuantity($passenger);
        });

        that.__setPetCabinMaxQuantity(related_select_segment_passengers_svcs_desktop, data, current_quantity);
        that.__setPetCabinMaxQuantity(related_select_segment_passengers_svcs_mobile, data, current_quantity);
    };

    /**
     * @param related_select_segment_passengers
     * @param data
     * @param total_quantity
     * @private
     */
    SvcsScreenLuggage.prototype.__disableSmartupLuggage = function (related_select_segment_passengers, data, total_quantity) {
        var that = this;

        related_select_segment_passengers.forEach(function (select_segment_passengers) {
            if (!select_segment_passengers.isSegmentTransfer() && select_segment_passengers['params']['svc_available_quantity'] > 0) {
                var $passengers = select_segment_passengers.getSegmentPassengersAll();
                $passengers.each(function () {
                    var $passenger = $(this);

                    if (select_segment_passengers.isPassengerSmartupSubscriber($passenger)) {
                        var current_quantity = select_segment_passengers.getPassengerQuantity($passenger);
                        if (total_quantity >= select_segment_passengers['params']['svc_available_quantity'] &&
                            current_quantity === 0
                        ) {
                            select_segment_passengers.setPassengerDisabled($passenger);
                        } else {
                            select_segment_passengers.unsetPassengerDisabled($passenger);
                        }
                    }
                });
            }
        });
    };

    /**
     * Проверка что не превышен лимит на заказ багажа со скидкой
     * @param data
     * @private
     */
    SvcsScreenLuggage.prototype.__checkRemainingSmartupLuggageQuantity = function (data) {
        var that = this,
            related_select_segment_passengers_svcs_desktop = that.__getAllSegmentsByParams(data.item_id, that.select_segment_passengers_desktop, that.smartup_luggage_max_quantity['type'], that.smartup_luggage_max_quantity['code_mask']),
            related_select_segment_passengers_svcs_mobile = that.__getAllSegmentsByParams(data.item_id, that.select_segment_passengers_mobile,  that.smartup_luggage_max_quantity['type'], that.smartup_luggage_max_quantity['code_mask']),
            total_quantity = that.__getLuggageQuantity(data.item_id);

        that.__disableSmartupLuggage(related_select_segment_passengers_svcs_desktop, data, total_quantity);
        that.__disableSmartupLuggage(related_select_segment_passengers_svcs_mobile, data, total_quantity);
    };

    // apply selection on other segments in direction
    SvcsScreenLuggage.prototype.__applySelectOnOtherDirectionSegments = function (data, direction_index_current, components_list_type, call_callback = true) {
        var that = this,
            item_quantity_main_segment = parseInt(data['item_quantity'], 10),
            svc_components = that['select_segment_passengers_' + components_list_type][data.item_id] || [];

        for (var select_segment_passengers of svc_components) {
            var direction_index = select_segment_passengers.getSegmentDirectionIndex();

            if ((direction_index === direction_index_current) && !select_segment_passengers.isThatSegment(data.segment_id)) {
                var $passenger = select_segment_passengers.getPassengerById(data['passenger_id']);

                if (!$passenger || !$passenger.length) {
                    continue;
                }

                var quantity = select_segment_passengers.isType(UISelectSegmentPassengers.prototype.TYPES.counter)
                        ? item_quantity_main_segment + select_segment_passengers.getPassengerCounterMin(data['passenger_id'])
                        : item_quantity_main_segment,
                    price = select_segment_passengers.getPassengerSelectionPrice($passenger) || 0;

                select_segment_passengers.select(
                    data['passenger_id'],
                    data['item_id'],
                    price,
                    {
                        item_text: data['item_text'],
                        is_segment_transfer: !!select_segment_passengers.isSegmentTransfer()
                    },
                    quantity,
                    data['item_quantity_diff'],
                    false, // do not call afterPassengerSelected callback - IMPORTANT
                    call_callback
                );
            }
        }
    }

    // apply reset on other segments in direction
    SvcsScreenLuggage.prototype.__applyResetOnOtherDirectionSegments = function (data, direction_index_current, components_list_type, call_callback = true) {
        var that = this,
            svc_components = that['select_segment_passengers_' + components_list_type][data.item_id] || [];

        svc_components.forEach(function (select_segment_passengers) {
            var direction_index = select_segment_passengers.getSegmentDirectionIndex();

            if ((direction_index === direction_index_current) && !select_segment_passengers.isThatSegment(data.segment_id)) {
                // resetPassenger() doesn't call afterPassengerReset callback by default
                select_segment_passengers.resetPassenger(data.passenger_id, call_callback);
            }
        });
    }

    SvcsScreenLuggage.prototype.__showSvcSegmentQtyTotal = function () {
        var that = this;

        that.luggage_selected_unpaid.forEach(function (item) {
            var item_id = item['item_id'].toString(),
                segment_id = item['segment_id'].toString(),
                item_price = parseFloat(item['item_price']),
                quantity,
                price;

            quantity = that.luggage_selected_unpaid.reduce(function (qty, current) {
                if (
                    current['item_id'].toString() === item_id &&
                    current['segment_id'].toString() === segment_id
                ) {
                    return qty + parseInt(current['item_quantity'], 10);
                } else {
                    return qty;
                }
            }, 0);

            price = item_price * quantity;

            if (quantity > 0) {
                that.__showSvcItemTotal(
                    segment_id,
                    item_id,
                    quantity,
                    price,
                    item['currency']
                );
            } else {
                that.__hideSvcItemTotal(segment_id, item_id);
            }
        });
    };

    SvcsScreenLuggage.prototype.__getLuggageQuantity = function (airline_svc_id, count_transfer_segments = true) {
        if (!airline_svc_id) {
            return 0;
        }

        var that = this,
            items = that.luggage_selected_unpaid.filter(selection => (
                selection.item_id.toString() === airline_svc_id.toString() && (count_transfer_segments ||
                (!count_transfer_segments && !selection.is_segment_transfer))
            ));

        return that.__countItemsQuantity(items);
    };

    SvcsScreenLuggage.prototype.__getLuggageQuantityAll = function () {
        var that = this;
        return that.__countItemsQuantity(that.luggage_selected_unpaid);
    };

    SvcsScreenLuggage.prototype.__countItemsQuantity = function (items) {
        if (!items.length) {
            return 0;
        }
        return items.reduce(function (quantity, item) {
            return quantity + parseInt(item['item_quantity'], 10);
        }, 0);
    };

    SvcsScreenLuggage.prototype.__showSvcItemTotal = function (segment_id, item_id, quantity, segment_price, currency) {
        var that = this;

        if (!quantity) {
            that.__hideSvcItemTotal(segment_id, item_id);
            return;
        }

        if (!segment_id || (Array.isArray(segment_id) && !segment_id.length) || !item_id || !currency) {
            return;
        }

        var total_segment_selector = '.' + that.class.svcs_luggage_total_segment;
        if (Array.isArray(segment_id)) {
            var data_attrs = [];
            segment_id.forEach(function (id) {
                data_attrs.push('[data-segment-id=' + id + ']');
            });
            total_segment_selector += data_attrs.join(',');
        } else {
            total_segment_selector += '[data-segment-id=' + segment_id + ']';
        }

        var $total_segment = that.$wrapper.find(total_segment_selector),
            $total_item = $total_segment.find('.' + that.class.svcs_luggage_total_item + '[data-id=' + item_id + ']'),
            $total_item_count = $total_item.find('.' + that.class.svcs_luggage_total_item_count),
            $total_item_amount = $total_item.find('.' + that.class.svcs_luggage_total_item_amount),
            segment_price_formatted = $.sa.format.price(parseFloat(segment_price), currency);

        $total_item_count.text('x' + parseInt(quantity, 10));
        $total_item_amount.text(segment_price_formatted);
        $total_item.show();
    }

    SvcsScreenLuggage.prototype.__hideSvcItemTotal = function (segment_id, item_id) {
        if (!segment_id || !item_id) {
            return;
        }

        var that = this,
            total_segment_selector = '.' + that.class.svcs_luggage_total_segment;

        if (Array.isArray(segment_id)) {
            var data_attrs = [];
            segment_id.forEach(function (id) {
                data_attrs.push('[data-segment-id=' + id + ']');
            });
            total_segment_selector += data_attrs.join(',');
        } else {
            total_segment_selector += '[data-segment-id=' + segment_id + ']';
        }

        var $total_segment = that.$wrapper.find(total_segment_selector),
            $total_item = $total_segment.find('.' + that.class.svcs_luggage_total_item + '[data-id=' + item_id + ']');

        $total_item.hide();
    };

    SvcsScreenLuggage.prototype.__changeTotal = function (value, multiplier = 1) {
        value = parseFloat(value);
        multiplier = parseFloat(multiplier);

        var that = this,
            amount = value * multiplier;

        if (amount < 0 && that.luggage_total < Math.abs(amount)) {
            $.sa.log('Error count total price');
        } else {
            that.luggage_total += amount;
        }
    };

    SvcsScreenLuggage.prototype.__displayTotal = function () {
        var that = this;

        if (!that.order_currency) {
            return;
        }

        var $total_amount = that.$wrapper.find('.' + that.class.svcs_luggage_total_amount),
            $total_amount_drawer = that.$wrapper.find('.' + that.class.svcs_luggage_total_drawer),
            total_amount_text = that.__formatTotalPrice();

        $total_amount.text(total_amount_text);

        // display total in drawer footer
        $total_amount_drawer.text(total_amount_text);
    };

    SvcsScreenLuggage.prototype.__formatTotalPrice = function () {
        var that = this;
        return $.sa.format.price(that.luggage_total, that.order_currency);
    };

    SvcsScreenLuggage.prototype.__setActionSubmitEmpty = function () {
        var that = this;
        that.__setActionSubmitTextFor('empty');
        that.__setActionSubmitTypeCancel();
    };

    SvcsScreenLuggage.prototype.__setActionSubmitAdd = function () {
        var that = this;
        that.__setActionSubmitTextFor('added', (!$.sa.is_desktop() ? ' ' + that.__formatTotalPrice() : ''));
        that.__setActionSubmitTypeConfirm();
    };

    SvcsScreenLuggage.prototype.__setActionSubmitConfirm = function () {
        var that = this;
        that.__setActionSubmitTextFor('confirm');
        that.__setActionSubmitTypeConfirm();
    };

    SvcsScreenLuggage.prototype.__setActionSubmitContinue = function () {
        var that = this;
        that.__setActionSubmitTextFor('continue');
        that.__setActionSubmitTypeConfirm();
    };

    SvcsScreenLuggage.prototype.__setActionSubmitTextFor = function (state, text_append = '') {
        var that = this,
            is_desktop = $.sa.is_desktop(),
            $action = that.$wrapper.find('.' + that.class.svc_action_submit),
            $action_text = is_desktop
                ? $action.find('.' + that.class.svc_action_submit_text_desktop)
                : $action.find('.' + that.class.svc_action_submit_text_mobile),
            text = '' + $action_text.data(state + '-text') + text_append;
        $action_text.text(text);
    };

    SvcsScreenLuggage.prototype.__setActionSubmitTypeCancel = function () {
        var that = this;
        that.$wrapper.find('.' + that.class.svc_action_submit)
            .addClass(that.class.svc_action_cancel)
            .removeClass(that.class.svc_action_confirm);
    };

    SvcsScreenLuggage.prototype.__setActionSubmitTypeConfirm = function () {
        var that = this;
        that.$wrapper.find('.' + that.class.svc_action_submit)
            .addClass(that.class.svc_action_confirm)
            .removeClass(that.class.svc_action_cancel);
    };

    SvcsScreenLuggage.prototype.__setSegmentDrawerActionSubmitState = function (state, $action) {
        var text;
        switch (state) {
            case 'added':
                text = $.sa.locales['add'];
                break;
            case 'empty':
                text = $.sa.locales['continue_without_service'];
                break;
            case 'confirm':
                text = $.sa.locales['confirm'];
                break;
            case 'continue':
                text = $.sa.locales['continue'];
                break;
        }
        $action.text(text);
    };

    /**
     * Applies select() on specified svcs.
     * Considers direction indexes.
     * @param {Object[]} svcs
     */
    SvcsScreenLuggage.prototype.applySelectOn = function (svcs) {
        var that = this,
            svcs_ids = svcs.map(svc => svc.item_id),
            // filter segments of that.select_segment_passengers_desktop: keep only one select_segment_passengers with one svc_id and direction_index combination
            select_segment_passengers_filtered = that.__getSvcsSelectSegmentPassengersOneForDirection(svcs_ids);

        // apply select only on filtered select_segment_passengers
        for (var key in select_segment_passengers_filtered) {
            var key_parts = key.split('-'),
                svc_id = key_parts[0] || null,
                select_segment_passengers = select_segment_passengers_filtered[key];

            if (!svc_id) {
                $.sa.error('initSelectSegmentPassengersDesktop(): __getSvcsSelectSegmentPassengersOneForDirection() keys have incorrect format.');
                break;
            }

            var svc_segment_id = select_segment_passengers.segment_id,
                svc_data_any_passenger = svcs.filter(selection => (
                    selection.item_id.toString() === svc_id &&
                    selection.segment_id.toString() === svc_segment_id.toString()
                ));

            if (!svc_data_any_passenger || !svc_data_any_passenger.length) {
                continue;
            }

            svc_data_any_passenger.forEach(function (svc_data) {
                var svc_passenger_id = svc_data['passenger_id'],
                    svc_quantity = svc_data['item_quantity'] ? parseInt(svc_data['item_quantity'], 10) : 0,
                    svc_price = svc_data['item_price'] ? parseFloat(svc_data['item_price']) : 0;

                // if it's counter - add min counter value to quantity
                if (select_segment_passengers.isType(select_segment_passengers.TYPES.counter)) {
                    var min_value = select_segment_passengers.getPassengerCounterMin(svc_passenger_id);
                    svc_quantity += min_value;
                }

                select_segment_passengers.select(
                    svc_passenger_id,
                    svc_id,
                    svc_price,
                    {
                        is_segment_transfer: !!select_segment_passengers.isSegmentTransfer()
                    },
                    svc_quantity,
                    svc_quantity,
                );
            })
        }
    };

    /**
     * Filter that.select_segment_passengers_desktop:
     * keep only one select_segment_passengers with one svc_id and direction_index combination
     * @param {int[]|string[]} svcs_ids Array of svc ids
     * @return {Object} Collection, where keys are strings like "svc_id-direction_index", and values are select_segment_passengers
     * @private
     */
    SvcsScreenLuggage.prototype.__getSvcsSelectSegmentPassengersOneForDirection = function (svcs_ids) {
        var that = this;

        var chosen_select_segment_passengers = {};
        // collect segment ids allowed for output
        for (var svc_id in that.select_segment_passengers_desktop) {
            // do not use Array.includes() - it provides strict comparison only
            if (!svcs_ids.some(id => id.toString() === svc_id.toString())) {
                continue;
            }
            var svc_select_segment_passengers = that.select_segment_passengers_desktop[svc_id];
            for (var _select_segment_passengers of svc_select_segment_passengers) {
                var direction_index = _select_segment_passengers.getSegmentDirectionIndex(),
                    key = `${svc_id}-${direction_index}`;

                if (chosen_select_segment_passengers.hasOwnProperty(key)) {
                    continue;
                }
                chosen_select_segment_passengers[key] = _select_segment_passengers;
            }
        }

        return chosen_select_segment_passengers;
    };

    SvcsScreenLuggage.prototype.isRenderedLuggageIncompleteWarning = function (screen_id, next_screen_id) {
        var that = this;

        if (!that.luggage_incomplete_warning_enable || screen_id !== 'luggage') {
            return false;
        }

        if (that.__isLuggageIncomplete()) {
            that.__renderLuggageIncompleteWarningModal(next_screen_id);
            return true;
        }

        return false;
    };

    SvcsScreenLuggage.prototype.__isLuggageIncomplete = function () {
        var that = this,
            svcs_selected = that.luggage_selected_unpaid,
            svcs_selected_clear;
        
        if (that.luggage_selected_paid.length) {
            svcs_selected = that.luggage_selected_paid.concat(svcs_selected); 
        }

        svcs_selected_clear = PageSvcs.prototype.svcsSelectedCleanSort(svcs_selected);

        if (!svcs_selected_clear.length) {
            return false;
        }

        for(var order_passenger_id of that.order_passengers_ids) {
            var passenger_id = parseInt(order_passenger_id, 10),
                passenger_matched = svcs_selected_clear.findIndex(function (svc_selected) {
                    return parseInt(svc_selected.passenger_id, 10) === passenger_id;
                });

            if (passenger_matched === -1) {
                continue;
            }

            // If there is a match by passenger_id in the svcs_selected_clear array,
            // then check is there a match in each segment
            for (var order_segment_id of that.order_segments_ids) {
                var segment_id = parseInt(order_segment_id, 10),
                    segment_matched = svcs_selected_clear.findIndex(function (svc_selected) {
                        return  parseInt(svc_selected.passenger_id, 10) === passenger_id &&
                                parseInt(svc_selected.segment_id, 10) === segment_id;
                    });

                // if segment matched remove object with this segment from array for next loop check
                if (segment_matched !== -1) {
                    svcs_selected_clear.splice(segment_matched, 1);
                }

                if (segment_matched === -1) {
                    return true;
                }
            }
        }
        
        return false;
    };

    SvcsScreenLuggage.prototype.__renderLuggageIncompleteWarningModal = function (next_screen_id) {
        var that = this;
        
        $.uiModal({
            html: that.luggage_incomplete_warning_html,
            onCancelClosed: function () {
                that.onLuggageIncompleteWarningCancelClosed(next_screen_id);
            }
        });
    };

    SvcsScreenLuggage.prototype.isRenderedLuggageAdditionalEmptyWarning = function (screen_id, next_screen_id) {
        var that = this;

        if (
            that.luggage_additional_empty_warning_enable && 
            screen_id === 'luggage' &&
            !that.luggage_additional_empty_warning_disallow &&
            that.__isAdditionalLuggageEmpty()
        ) {
            that.__renderAdditionalLuggageEmptyModal(next_screen_id);
            return true;
        }
        
        return false;
    };

    SvcsScreenLuggage.prototype.__isAdditionalLuggageEmpty = function () {
        var that = this,
            luggage_svc_selected_clear = PageSvcs.prototype.svcsSelectedCleanSort(that.luggage_selected_unpaid);

        return !luggage_svc_selected_clear.length;
    };

    SvcsScreenLuggage.prototype.__renderAdditionalLuggageEmptyModal = function (next_screen_id) {
        var that = this;

        $.uiModal({
            html: that.luggage_additional_empty_warning_html,
            onCancelClosed: function () {
                that.onLuggageAdditionalEmptyWarningCancelClosed(next_screen_id);
            },
            onButtonConfirmClick: function (){
                that.luggage_additional_empty_warning_disallow = true;
            },
        });
    };

    return SvcsScreenLuggage;
})($);
